import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TradingJournalApp from './TradingJournalPro';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TradingJournalApp />
  </React.StrictMode>
);
